// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = "https://udygtoygcqcbbkewygna.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVkeWd0b3lnY3FjYmJrZXd5Z25hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAxNTUwOTMsImV4cCI6MjA0NTczMTA5M30.HdHqoOzWYo9KyHxUbgnh52j-gajxvtRF_5-FUNAXw_A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);